export default "__VITE_ASSET__BLq1Id9W__"